import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React, { createContext, useState, useEffect, useRef } from 'react';
import Theme from './theme';
export var TabsTheme = Theme;
/*::
import type { Node, ComponentType } from 'react';
import type { PanelComponentProps } from './panel';
import type { TabsThemeType } from './theme';
import type { StyledComponent } from 'styled-components';

export type OnChangeType = (id: string) => void;

type TabsPropsType = {|
  value?: ?string,
  onChange?: OnChangeType,
  panel?: ComponentType<PanelComponentProps>,
  panels?: Node,
  scrollable?: boolean,
  scrollStep?: number,
  children?: Node,
  theme?: TabsThemeType,
  rest?: any,
|};

type TabsContextType = {|
  activeTab: string,
  onTabClick: OnChangeType,
  setActiveTab: (activeTab: string) => void,
|};
*/

var defaultTabsContextValues
/*: TabsContextType */
= {
  activeTab: '',
  onTabClick: function onTabClick() {
    return undefined;
  },
  setActiveTab: function setActiveTab() {
    return undefined;
  }
};
export var TabsContext = /*#__PURE__*/createContext
/*:: <TabsContextType> */
(defaultTabsContextValues);

var Tabs = function Tabs(_ref
/*: TabsPropsType */
, ref) {
  var _ref$value = _ref.value,
      value = _ref$value === void 0 ? null : _ref$value,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return undefined;
  } : _ref$onChange,
      _ref$panel = _ref.panel,
      panel = _ref$panel === void 0 ? null : _ref$panel,
      _ref$panels = _ref.panels,
      panels = _ref$panels === void 0 ? null : _ref$panels,
      _ref$scrollable = _ref.scrollable,
      scrollable = _ref$scrollable === void 0 ? false : _ref$scrollable,
      _ref$scrollStep = _ref.scrollStep,
      scrollStep = _ref$scrollStep === void 0 ? 40 : _ref$scrollStep,
      children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? Theme : _ref$theme,
      rest = _objectWithoutPropertiesLoose(_ref, ["value", "onChange", "panel", "panels", "scrollable", "scrollStep", "children", "theme"]);

  var leftRef = useRef();
  var rightRef = useRef();
  var listRef = useRef();

  var _useState = useState(value || ''),
      activeTab = _useState[0],
      setActiveTab = _useState[1];

  var CustomPanel = panel;
  useEffect(function () {
    if (listRef && listRef.current && listRef.current.offsetWidth && listRef.current.scrollWidth && rightRef && rightRef.current && rightRef.current.style) {
      var _listRef$current = listRef.current,
          offsetWidth = _listRef$current.offsetWidth,
          scrollWidth = _listRef$current.scrollWidth;

      if (offsetWidth >= scrollWidth) {
        rightRef.current.style.width = '0';
        rightRef.current.style.height = '0';
        rightRef.current.style.top = '50%';
        rightRef.current.style.borderWidth = '0';
      }
    }
  }, []);
  useEffect(function () {
    if (value !== null) {
      setActiveTab(value);
    }
  }, [value]);

  function handleListScroll(e) {
    var _e$currentTarget = e.currentTarget,
        scrollLeft = _e$currentTarget.scrollLeft,
        offsetWidth = _e$currentTarget.offsetWidth,
        scrollWidth = _e$currentTarget.scrollWidth;
    var scrollRight = scrollWidth - scrollLeft - offsetWidth;

    if (leftRef && leftRef.current && leftRef.current.style && rightRef && rightRef.current && rightRef.current.style) {
      leftRef.current.style.width = scrollLeft <= 0 ? '0' : '5rem';
      leftRef.current.style.height = scrollLeft <= 0 ? '0' : '100%';
      leftRef.current.style.top = scrollLeft <= 0 ? '50%' : '0';
      leftRef.current.style.borderWidth = scrollLeft <= 0 ? '0' : '3px';
      rightRef.current.style.width = scrollRight <= 0 ? '0' : '5rem';
      rightRef.current.style.height = scrollRight <= 0 ? '0' : '100%';
      rightRef.current.style.top = scrollRight <= 0 ? '50%' : '0';
      rightRef.current.style.borderWidth = scrollRight <= 0 ? '0' : '3px';
    }
  }

  var scrollLeft = function scrollLeft() {
    if (listRef && listRef.current) {
      listRef.current.scrollLeft -= scrollStep;
    }
  };

  var scrollRight = function scrollRight() {
    if (listRef && listRef.current) {
      listRef.current.scrollLeft += scrollStep;
    }
  };

  return /*#__PURE__*/React.createElement(TabsContext.Provider, {
    value: {
      activeTab: activeTab,
      onTabClick: onChange,
      setActiveTab: setActiveTab
    }
  }, /*#__PURE__*/React.createElement(theme.Main, Object.assign({
    ref: ref,
    "data-test": "tabs-main",
    scrollable: scrollable
  }, rest), /*#__PURE__*/React.createElement(theme.ScrollContainer, {
    scrollable: scrollable
  }, scrollable && /*#__PURE__*/React.createElement(theme.ScrollLeft, {
    ref: leftRef,
    onClick: scrollLeft
  }), /*#__PURE__*/React.createElement(theme.List, {
    "data-test": "tabs-list",
    ref: listRef,
    onScroll: scrollable ? handleListScroll : function () {
      return undefined;
    },
    scrollable: scrollable
  }, children), scrollable && /*#__PURE__*/React.createElement(theme.ScrollRight, {
    ref: rightRef,
    onClick: scrollRight
  })), panel ? /*#__PURE__*/React.createElement(CustomPanel, {
    id: activeTab
  }) : panels));
};

export default /*#__PURE__*/React.forwardRef
/*:: <TabsPropsType, StyledComponent> */
(Tabs);